"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SfavSectionKey = void 0;
var SfavSectionKey;
(function (SfavSectionKey) {
    SfavSectionKey[SfavSectionKey["PROPERTY"] = 0] = "PROPERTY";
    SfavSectionKey[SfavSectionKey["CRITERIA"] = 1] = "CRITERIA";
    SfavSectionKey[SfavSectionKey["HISTORY"] = 2] = "HISTORY";
    SfavSectionKey[SfavSectionKey["PROPERTY_INT"] = 3] = "PROPERTY_INT";
    SfavSectionKey[SfavSectionKey["HISTORY_INT"] = 4] = "HISTORY_INT";
    SfavSectionKey[SfavSectionKey["PLACE"] = 5] = "PLACE";
})(SfavSectionKey = exports.SfavSectionKey || (exports.SfavSectionKey = {}));
